export default "__VITE_ASSET__3625e035__"